import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { useLenis } from "@/hooks/useLenis";
import { Layout } from "@/components/site/Layout";
import { CookieConsentProvider } from "@/components/site/CookieConsent";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Projects from "@/pages/Projects";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import AdminLeads from "@/pages/AdminLeads";

const ProtectedRoute = ({ children }) => {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-void font-mono text-xs uppercase tracking-widest text-white/40">
        Loading…
      </div>
    );
  }
  return user ? children : <Navigate to="/login" replace />;
};

function App() {
  useLenis();
  return (
    <div className="App">
      <AuthProvider>
        <Toaster theme="dark" position="top-center" richColors />
        <BrowserRouter>
          <CookieConsentProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route
              path="/admin/enquiries"
              element={
                <ProtectedRoute>
                  <AdminLeads />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </CookieConsentProvider>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
